import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { IReminderListGetQuery, IReminderListGetQueryResult, ReminderDeleteCommandResult, ReminderDto, ReminderInitializeCommandResult, ReminderSetCommandResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IReminderApiService {

  abstract reminderListGet(
    params?: Partial<IReminderListGetQuery>,
    allowCancellation?: boolean | undefined
  ): Observable<IReminderListGetQueryResult>;

  abstract reminderSet(reminder?: ReminderDto | undefined): Observable<ReminderSetCommandResult>;

  abstract reminderInitialize(reminder?: ReminderDto | undefined): Observable<ReminderInitializeCommandResult>;

  abstract reminderDelete(userNumber: string): Observable<ReminderDeleteCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IReminderApiServiceToken = new InjectionToken<IReminderApiService>('IReminderApiServiceToken');
